"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationProvider = exports.useTranslationContext = void 0;
const react_1 = __importStar(require("react"));
const translation_1 = require("../translation");
const TranslationContext = (0, react_1.createContext)({});
const useTranslationContext = () => {
    return (0, react_1.useContext)(TranslationContext);
};
exports.useTranslationContext = useTranslationContext;
const TranslationProvider = ({ projectId, env, children }) => {
    const [translations, setTranslations] = (0, react_1.useState)();
    const loadTranslations = (0, react_1.useCallback)(async () => {
        const translations = await (0, translation_1.fetchTranslation)(projectId, env);
        setTranslations(translations || {});
    }, []);
    (0, react_1.useEffect)(() => {
        loadTranslations();
        if (!localStorage?.getItem('locale')) {
            localStorage.setItem('locale', 'en_US');
        }
    }, []);
    if (!translations)
        return null;
    return react_1.default.createElement(TranslationContext.Provider, { value: { translations } }, children);
};
exports.TranslationProvider = TranslationProvider;
//# sourceMappingURL=TranslationProvider.js.map